// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"64eefb5e","256":"44213356","596":"08d59d54","662":"a4852f24","676":"a68426a7","690":"8b6a63b4","972":"1756715e"}[chunkId] + ".chunk.js";
};